import Card from "./Card";
import Titlebar from "./Titlebar";

function Cv(props) {
    return (
        <Card>
            <Titlebar content="Curriculum Vitae"></Titlebar>
            <div className="cv">
            Coming soon...
            </div>
        </Card>
    );
}

export default Cv;